import { cn } from '@/lib/utils'

/** Tichý neutrální štítek role nebo stavu uživatele. */
export const RoleBadge = ({ children, muted, className }: { children: React.ReactNode; muted?: boolean; className?: string }) => (
  <span
    className={cn(
      'inline-flex h-5 items-center rounded-full px-2 text-xs font-medium whitespace-nowrap',
      muted ? 'border text-muted-foreground' : 'bg-neutral-bg text-foreground',
      className,
    )}
  >
    {children}
  </span>
)
